import { Subscription } from '@price-card/models/subscription.model';

type SubscriptionEntity = {
  id: number;
  filename: string;
  zone: {
    id: number;
    name: string;
    alias: string;
  };
  subtype: {
    id: number;
    name: string;
  };
  cods: {
    id: number;
    year: number;
  }[];
  expirationDate: string;
}

export class SubscriptionMapper {
   mapArrayToDomainModel = (subscriptionEntities: SubscriptionEntity[]): Subscription[] =>
     subscriptionEntities.map(subscriptionEntity => this.mapToDomainModel(subscriptionEntity));

  mapToDomainModel = (subscriptionEntity: SubscriptionEntity): Subscription => ({
        id: subscriptionEntity.id,
        priceCardName: subscriptionEntity.filename.split('.')[0],
        priceZone: {
          id: subscriptionEntity.zone.id,
          name: subscriptionEntity.zone.name,
          alias: subscriptionEntity.zone.alias
        },
        technology: {
          id: subscriptionEntity.subtype.id,
          name: subscriptionEntity.subtype.name
        },
        commercialOperationDates: subscriptionEntity.cods,
        expirationDate: subscriptionEntity.expirationDate
     });

  mapToDTO = (subscriptionModel: Subscription): {zoneId: number, subtypeId: number, codIds: number[]} => ({
    zoneId: subscriptionModel.priceZone.id,
    subtypeId: subscriptionModel.technology.id,
    codIds: subscriptionModel.commercialOperationDates.map(cod => cod.id)
  });
}
